import idHomeJson from 'modules/Home/constant/id-ID.json';
import idAuditJson from 'modules/Audit/constant/id-ID.json';
import idOrganizationJson from 'modules/Organization/constant/id-ID.json';
import idUserControlJson from 'modules/UserControl/constant/id-ID.json';
import idAllBillers from 'modules/AllBillers/constant/id-ID.json';
import idGold from 'modules/Gold/constant/id-ID.json';
import idDelivery from 'modules/Delivery/constant/id-ID.json';

import idJson from './id-ID.json';

const id = {
  ...idJson,
  ...idAuditJson,
  ...idHomeJson,
  ...idOrganizationJson,
  ...idUserControlJson,
  ...idAllBillers,
  ...idGold,
  ...idDelivery,
};

export default id;
